import WindowManager from './WindowManager';



export default new WindowManager();



// WEBPACK FOOTER //
// ./src/js/manager/window-manager/index.js